import {useCurrentMaterialStorages} from '@domain/material-storage'
import {UseQueryResult} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {EquipmentOption, EquipmentOptionType} from '../../types'

import {useUrlParam} from '@settings/modules/routing'

export const useStorageOptionsQuery = (): UseQueryResult<EquipmentOption[]> => {
  const plantCode = useUrlParam('plantCode')
  const {t} = useTranslation()

  return useCurrentMaterialStorages({
    plantId: plantCode,
    options: {
      select: (storages) =>
        storages
          .map<EquipmentOption>(({id, name}) => ({
            id,
            label: name,
            type: EquipmentOptionType.storage
          }))
          .sort((current, next) => (current.label > next.label ? 1 : -1)),
      meta: {
        errorMessage: t('samplingPointsSettings.queries.fetchStoragesError')
      }
    }
  })
}
